export default __webpack_public_path__ + "static/media/info-circle-purple.a77d9088.svg";